<template>
  <card title="Category Information">
    <v-container grid-list-md >
      <v-layout wrap>

        <v-flex
          xs4
          sm4
          sd4
        >
          <label>Picture</label>
          <el-upload
            :action="actionUrl"
            :show-file-list="false"
            :headers="{ Authorization: 'Bearer ' + token }"
            :data="{ type: 'category' }"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            class="category-picture-uploader"
            name="image"
          >
            <el-image
              v-if="editedItem.image_url"
              :src="editedItem.image_url"
              fit="fill"/>

            <i
              v-else
              class="el-icon-plus category-picture-uploader-icon"/>
          </el-upload>
        </v-flex>
        <v-flex
          xs8
          sm8
          md8>
          <v-flex
            xs12
            sm12
            md12>
            <base-input
              v-model="editedItem.id"
              required
              label="Category Id(Change Not recommended)" />
          </v-flex>
          <v-flex
            xs12
            sm12
            md12>
            <base-input
              v-model="editedItem.name"
              required
              label="Category Name" />
          </v-flex>
          <v-flex
            xs12
            sm12
            md12>
            <base-input
              v-model="editedItem.display_order"
              required
              type="number"
              label="Display Order" />
          </v-flex>
          <v-flex>

            <label>Description</label>
            <textarea
              v-model="editedItem.description"
              rows="5"
              maxlength="256"
              class="form-control"
              label="Description"/>
          </v-flex>
          <v-flex
            xs12
            sm12
            md12>
            <base-checkbox
              v-model="editedItem.active"
            > Active </base-checkbox>
          </v-flex>

        </v-flex>
      </v-layout>
    </v-container>

    <v-card-actions>

      <v-spacer/>
      <base-button
        type="primary"
        @click="save">Save</base-button>
    </v-card-actions>
    <v-snackbar
      v-model="snack"
      :timeout="5000"
      :color="snackColor">
      {{ snackText }}
      <v-btn
        flat
        @click="snack = false">Close</v-btn>
    </v-snackbar>
  </card>
</template>

<style>

.category-picture-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.category-picture-uploader .el-upload:hover {
  border-color: #409EFF;
}

.category-picture-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 99px;
  height: 99px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px !important;
  height: 178px;
  display: block;
}

</style>

<script>
import axios from 'axios'
import BaseButton from '@/components/BaseButton'
import { mapState } from 'vuex'

export default {
  components: { BaseButton },
  props: {
    item: {
      type: Object,
      default: {}
    },
    editedIndex: {
      type: Number,
      default: -1
    }
  },
  data: () => ({
    snack: false,
    snackColor: '',
    snackText: '',
    initialId: '',
    editedItem: {
      id: '',
      name: '',
      description: '',
      image_url: '',
      active: true
    }
  }),
  computed: {
    ...mapState(['token']),
    actionUrl: function () {
      return process.env.VUE_APP_API_BASE_URL + '/images/'
    }
  },
  mounted () {
    if (Object.keys(this.item).length !== 0) {
      this.editedItem = this.item
      this.initialId = this.editedItem.id
    }
  },
  methods: {
    save () {
      // update
      if (this.editedIndex !== -1) {
        this.$store.state.spinning = true
        axios.put('/categories/' + this.initialId, this.editedItem)
          .then((response) => {
            this.$emit('update', response.data)
            this.editedItem = response.data
            this.$store.state.spinning = false
          }
          )
          .catch(error => {
            console.log('new log')
            if (error.response.status === 422) {
              this.showError(JSON.stringify(error.response.data.errors))
            }
            console.log(error)
            this.$store.state.spinning = false
          })
      }
      // create
      else {
        this.$store.state.spinning = true
        axios.post('/categories', this.editedItem)
          .then((response) => {
            this.$emit('create', response.data)
            this.$store.state.spinning = false
          })
          .catch(error => {
            if (error.response.status == '422') {
              this.showError(JSON.stringify(error.response.data.errors))
            }
            console.log(error)
            this.$store.state.spinning = false
          })
      }
    },

    handleAvatarSuccess (res) {
      this.editedItem.image_url = res.path
      this.$store.state.spinning = false
    },

    beforeAvatarUpload (file) {
      var mimes = ['image/png', 'image/jpeg', 'image/gif', 'image/jpg']
      const isValid = mimes.includes(file.type)
      const isLt50M = file.size / 1024 / 1024 < 50

      if (!isValid) {
        this.$message.error(
          '图片必须是以下类型的图片 JPG, JPEG, GIF or GIF format!'
        )
      }
      if (!isLt50M) {
        this.$message.error('图片最大不超过50MB!')
      }
      this.$store.state.spinning = true
      return isValid && isLt50M
    },

    showError (errorMessage) {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = errorMessage || 'Something went wrong, try again later!'
    }
  }
}
</script>
